import { render, staticRenderFns } from "./AccountCenter.vue?vue&type=template&id=636de483&scoped=true"
import script from "./AccountCenter.vue?vue&type=script&lang=js"
export * from "./AccountCenter.vue?vue&type=script&lang=js"
import style0 from "./AccountCenter.vue?vue&type=style&index=0&id=636de483&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "636de483",
  null
  
)

export default component.exports